import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from '../../infrastructure/services/loader.service';
import { Location } from '@angular/common';
import {
  ConsultaSimpleService,
  ConsultaSimple,
  ConfigComandoConsultasimple,
} from '../../infrastructure/services/consultaSimple.service';
import { Observable } from 'rxjs/Observable';
import { ListadaAgrupada } from '../../infrastructure/services/config.service';

@Component({
  templateUrl: 'configurar.consulta.simple.component.html',
})
export class ConfigurarConsultaSimpleComponent implements OnInit {
  codSistema: string;
  codNegocio: string;
  codProducto: string;
  codComando: string;
  esNuevo: boolean;
  comandoValido: boolean = false;
  consultaSimple: ConsultaSimple;
  grupos: Observable<ListadaAgrupada[]>;

  constructor(
    private aRoute: ActivatedRoute,
    private router: Router,
    private consultaSimpleService: ConsultaSimpleService,
    private location: Location,
    public loader: LoaderService
  ) {}

  ngOnInit() {
    this.comandoValido = true;
    this.aRoute.params.subscribe((params) => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProducto = params['codproducto'];
      this.codComando = params['codcomando'];

      this.esNuevo = false;

      // Si estoy creando un nuevo Comando
      if (this.codComando === 'nuevo') {
        this.esNuevo = true;

        this.consultaSimple = {
          codInstalacionV5: this.codSistema,
          codNegocio: this.codNegocio,
          codProducto: this.codProducto,
          comando: {
            codServicio: 'SrvConsultaSimple',
            codComando: '',
            descripcion: '',
          },
        };
        return;
      }

      this.grupos = this.consultaSimpleService.getComando(this.codComando, this.codSistema, this.codNegocio, this.codProducto);
    });
  }

  validateCommand(command: string) {
    const regex = /[^!.,;:"#$%&={}()\[\]*-\s]$/g;
    const validation = regex.test(command);

    if (!validation) this.comandoValido = false;
    else this.comandoValido = true;
  }

  consultaDelete() {
    this.consultaSimpleService
      .deleteCommando(
        this.codSistema,
        this.codNegocio,
        this.codProducto,
        this.codComando
      )
      .then((x) => this.volverAlListado());
  }

  guardar() {
    this.consultaSimpleService
      .crearComandocrearConsultaSimple(this.consultaSimple)
      .then(this.volverAlListado.bind(this));
  }

  cancelar() {
    this.volverAlListado();
  }

  private volverAlListado() {
    this.router.navigate(['../'], { relativeTo: this.aRoute });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/consultaSimple/configurar.consulta.simple.component.ts